const CONSENT_KEY = "aideal-cookie-consent";

type ConsentValue = "accepted" | "rejected" | null;

export function getConsent(): ConsentValue {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === "accepted" || stored === "rejected") return stored;
    return null;
  } catch {
    return null;
  }
}

export function setConsent(value: "accepted" | "rejected"): void {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // localStorage unavailable, silently ignore
  }
}

export function hasAnalyticsConsent(): boolean {
  return getConsent() === "accepted";
}

export function loadGoogleAnalytics(measurementId?: string): void {
  const id = measurementId || (typeof import.meta !== "undefined" && (import.meta as Record<string, unknown>).env
    ? ((import.meta as Record<string, unknown>).env as Record<string, string>).VITE_PUBLIC_GA_MEASUREMENT_ID
    : undefined);

  if (!id || typeof window === "undefined") return;

  // Don't inject twice
  if (document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  const inline = document.createElement("script");
  inline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${id}', { anonymize_ip: true });
  `;
  document.head.appendChild(inline);
}